import Model from './Model'

export default class SurveyModel extends Model {
  id!: number

  resource () : string {
    return 'surveys'
  }
}
